export const brandInfo = {
  name: "萝莉风格时尚穿搭指南",
  nameEn: "Lolita Fashion Style Guide",
  tagline: "探索萝莉风格的时尚世界",
  description: "从洛丽塔服饰文化、甜美穿搭技巧到配件搭配，全面解析萝莉美学的起源与现代演绎，助你打造属于自己的独特风格。",
  founded: "2023年",
  location: "中国·上海",
  email: "hello@lolitastyle.cn",
  phone: "+86 21-8888-6666",
  social: {
    weibo: "https://weibo.com/lolitastyle",
    wechat: "lolitastyle_official",
    xiaohongshu: "https://www.xiaohongshu.com/user/lolitastyle",
    bilibili: "https://space.bilibili.com/lolitastyle"
  }
};

export const teamMembers = [
  {
    name: "樱花酱",
    role: "创始人 & 主编",
    description: "洛丽塔文化深度爱好者，拥有10年以上洛丽塔穿搭经验，曾多次参加国内外洛丽塔茶会和时尚活动。",
    avatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20pink%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20gentle%20smile%2C%20professional%20headshot&width=400&height=400&seq=team-av-1&orientation=squarish"
  },
  {
    name: "小鹿斑比",
    role: "资深编辑",
    description: "日系时尚研究者，擅长甜美系和森女系穿搭分析，在多个时尚平台发表过穿搭专栏。",
    avatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20brown%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20warm%20smile%2C%20professional%20headshot&width=400&height=400&seq=team-av-2&orientation=squarish"
  },
  {
    name: "蜜桃酱",
    role: "造型顾问",
    description: "专业洛丽塔造型师，参与过多个品牌的Lookbook拍摄，擅长为客户打造个性化洛丽塔造型。",
    avatar: "https://readdy.ai/api/search-image?query=Soft%20anime%20style%20portrait%20of%20young%20woman%20with%20peach%20colored%20hair%2C%20cute%20Japanese%20illustration%2C%20simple%20clean%20background%2C%20bright%20smile%2C%20professional%20headshot&width=400&height=400&seq=team-av-3&orientation=squarish"
  }
];

export const testimonials = [
  {
    name: "小兔纸",
    location: "广州",
    rating: 5,
    comment: "这个网站真的帮了我很多！作为一个洛丽塔新手，以前总觉得自己穿起来怪怪的，看了这里的穿搭指南才知道原来是配饰没搭对。现在朋友们都说我越来越会穿了！"
  },
  {
    name: "CherryBlossom",
    location: "杭州",
    rating: 5,
    comment: "特别喜欢分类文章的部分，从洛丽塔文化科普到具体的穿搭技巧，内容既专业又易懂。蕾丝搭配那篇文章我反复看了好几遍，收获超大！"
  },
  {
    name: "奶茶星人",
    location: "成都",
    rating: 5,
    comment: "作为日系风格的忠实粉丝，这里的文章每一篇都不想错过。特别是日系少女风的演变史那篇，写得特别详细，让我对不同风格有了更清晰的认识。"
  },
  {
    name: "星野爱",
    location: "北京",
    rating: 4,
    comment: "品牌推荐和配件搭配的内容非常实用，帮我省了不少冤枉钱。希望之后能看到更多关于不同身材类型穿洛丽塔的专题内容！"
  }
];

export const faqs = [
  {
    question: "萝莉风格和洛丽塔风格有什么区别？",
    answer: "萝莉风格（Lolita Style）是一个更广泛的概念，涵盖了所有甜美、少女感的穿搭风格，而洛丽塔（Lolita Fashion）特指源自日本的、以维多利亚时代为灵感的特定服饰文化。简单来说，洛丽塔是萝莉风格的一个子集，但更加规范和体系化。"
  },
  {
    question: "洛丽塔服饰是否只能在特殊场合穿着？",
    answer: "完全不是！虽然一些华丽的茶会款确实更适合聚会和拍照，但日常洛丽塔（Casual Lolita）完全可以在日常生活中穿着。选择剪裁简洁、印花低调的款式，搭配日常配件，就能轻松将洛丽塔融入日常穿搭。"
  },
  {
    question: "洛丽塔穿搭的预算大概需要多少？",
    answer: "洛丽塔穿搭的预算弹性很大，从几百元到几千元不等。国牌入门款连衣裙约在300-800元，日牌中高端款在1500-5000元左右。裙撑、头饰等配件的花费在50-300元不等。建议初学者从国牌入门款开始尝试。"
  },
  {
    question: "萝莉风格适合什么年龄段的女生？",
    answer: "萝莉风格没有严格的年龄限制！从十几岁的少女到三十多岁的成熟女性都可以驾驭。关键在于选择适合自己气质和场合的款式。年轻的女孩可以大胆尝试各种甜美元素，成熟女性则可以选择古典洛丽塔或简约日系风格，优雅又减龄。"
  },
  {
    question: "如何开始打造自己的萝莉风格衣橱？",
    answer: "建议从以下几步开始：1）确定自己喜欢的风格流派（甜美/古典/哥特/日常日系）；2）先入手基础单品如一件百搭的JSK连衣裙；3）逐步添置裙撑、头饰、袜子等配件；4）多看穿搭参考，找到适合自己的搭配方式。"
  }
];